import { type FC, useMemo, useState } from "react";
import PageTitle from "~/common/components/PageTitle/v1/PageTitle";
import ContactUsForm from "~/features/contactUs/components/ContactUsForm";
import ContactUsSidebar from "~/features/contactUs/components/ContactUsSidebar";
import { Col, Row } from "~/common/components/Layout";
import { useTranslation } from "react-i18next";
import { Alert } from "~/common/mui/Alert/Alert";
import {
  ContactUsConfirmationPageView,
  type Props as ContactUsConfirmationProps,
} from "~/pages/ContactUsConfirmationPage/ContactUsConfirmationPage";
import { type ContactUsDisplayProps } from "~/features/contactUs/types";

export const ContactUsPage: FC<ContactUsDisplayProps> = (props) => {
  const { t } = useTranslation();
  const [confirmation, setConfirmation] = useState<ContactUsConfirmationProps>();
  const subjects = useMemo(() => {
    return props.subjects.map((subject) => ({
      label: t(subject),
      value: subject,
    }));
  }, [props.subjects, t]);

  return (
    <>
      <PageTitle title={t("contactUsPage.title")} />

      {props.serverError && (
        <Alert severity="error" className="mb-3">
          {t(props.serverError)}
        </Alert>
      )}

      {confirmation ? (
        <ContactUsConfirmationPageView {...confirmation} />
      ) : (
        <Row>
          <Col size={8}>
            <ContactUsForm {...props} subjects={subjects} onSubmitSuccess={setConfirmation} />
          </Col>

          <Col size={4}>
            <ContactUsSidebar fullAddress={props.salesRepresentative.fullAddress} imageSrc={props.contactImageSrc} />
          </Col>
        </Row>
      )}
    </>
  );
};

export function createContactUsPage(data: ContactUsDisplayProps) {
  return <ContactUsPage {...data} />;
}
